// extracted by mini-css-extract-plugin
export default {"parameter":"TextareaInput_parameter__u2wyN","parameterTitle":"TextareaInput_parameterTitle__7yono"};